<template>
  <v-container class="pa-0 pa-sm-2 pt-12 mt-12 chapter-social" fluid >
    <v-row class="pt-12 my-12" id="chapter-social" v-intersect="onIntersect" :no-gutters="$vuetify.breakpoint.xsOnly">
      <v-col cols="12" md="10" offset-md="1" class="px-0 px-sm-6 px-md-12 pt-md-12 mt-md-12">
        <v-row class="mx-4 mx-sm-0 pb-12 border-bottom-grey" align-content="center">
          <h2>{{$root.siteSettings.socialMediaTitle}}</h2>
        </v-row>

        <v-row justify="end" class="mx-2 mx-sm-0 my-6 my-md-12">
          <v-col cols="12" md="8">
            <p class="subtitle">{{$root.siteSettings.socialMediaDescription}}</p>
          </v-col>
        </v-row>

        <v-row align-content="center" class="px-4 px-sm-0">
          <v-col cols="auto" v-for="(item, index) in socialData" :key="index" :style="{ 'width': (100 / socialData.length) + '%'}" class="text-center px-2 px-md-3">
            <div class="progress-background">
              <div class="progress-fill" :style="{ 'transform': 'scale3d(' + ((activeTab > index) ? 1 : (activeTab === index) ? progress : 0) + ', 1, 1)' }"></div>
            </div>
          </v-col>
        </v-row>
            <!-- :style="{marginLeft: '-8.3333333333%', width: '100vw'}" -->
            <!-- cycle -->
            <!-- continuous -->
            <!-- interval="200000000" -->
        <v-carousel
            hide-delimiters
            v-model="activeTab"
            :height="Math.min(viewPort.height, 800)"
            delimiter-icon="mdi-minus"
            :show-arrows="false"
            @change="onChange"
          >
            <v-carousel-item v-for="(social, index) in socialData" :key="index">
              <v-row
                class="fill-height"
                align="start"
                align-sm="center"
                justify="center"
              >
                <div class="display-3">
                  <instagram-embed
                    v-if="isActive"
                    :url="social"
                    :max-width="800"
                    :hide-caption="true"
                  />
                </div>
              </v-row>
            </v-carousel-item>
          </v-carousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import anime from 'animejs'
import { Viewport } from '@monogrid/vue-lib'
import InstagramEmbed from 'vue-instagram-embed'
import sampleSize from 'lodash/sampleSize'

export default {
  name: 'ChapterSocial',

  mixins: [Viewport],

  components: {
    InstagramEmbed
  },

  props: {
    data: {
      type: Array,
      required: false
    }
  },

  // farne vedere max 10 random

  data () {
    return {
      isActive: false,
      progress: 0.0,
      activeTab: 0
    }
  },

  mounted () {
    this.progress = 0

    this.loopCarousel()
    // if (this.isActive) {
    //   anime({
    //     targets: this,
    //     progress: [0, 1],
    //     duration: 20000,
    //     easing: 'linear'
    //   })
    // }

    // this.$events.$on('scrollto:begin', () => {
    //   this.isActive = true
    // })
  },

  destroyed () {
    this.$events.$off('scrollto:begin')
  },

  methods: {
    onIntersect (entries, observer, isIntersecting) {
      this.isActive = isIntersecting
      // console.log('this is active?', this.isActive)
      this.loopCarousel()
      // if (isIntersecting && this.isActive) {
      //   this.setAsCurrentSection()
      // }
    },

    loopCarousel () {
      if (this.isActive) {
        // console.log('looping carousel')
        this.activeTab++
        if (this.activeTab > this.socialData.length - 1) {
          this.activeTab = 0
        }
        this.progress = 0
        anime.remove(this)
        anime({
          targets: this,
          progress: [0, 1],
          duration: 20000,
          easing: 'linear',
          complete: this.loopCarousel
        })
      }
    },

    // setAsCurrentSection () {
    //   this.$emit('route:update', 'social')
    // },

    onChange (index) {
      this.activeTab = index
      this.progress = 0
      // console.log('on change social media')
      if (this.isActive) {
        anime.remove(this)
        anime({
          targets: this,
          progress: [0, 1],
          duration: 20000,
          easing: 'linear',
          complete: this.loopCarousel
        })
      }
    }
  },

  computed: {
    socialData () {
      return sampleSize(this.data, 10)
    }
  }

  // watch: {
  //   isActive () {
  //     if (this.isActive) {
  //       anime.remove(this)
  //       anime({
  //         targets: this,
  //         progress: [0, 1],
  //         duration: 20000,
  //         easing: 'linear'
  //       })
  //     }
  //   }
  // }
}
</script>

<style scoped lang="scss">

.chapter-social {
  pointer-events: all;
}

.progress-background {
  width: 100%;
  height: 2px;

  background-color: $c-text-grey;
  transform-origin: left center;

  will-change: transform;
  backface-visibility: hidden;
  position: relative;

  .progress-fill {
    position: absolute;

    top: 0;
    left: 0;

    background-color: $c-light-grey;

    width: 100%;
    height: 100%;

    transform: scale3d(0, 1, 1);
    transform-origin: left center;
  }
}
</style>
